import { unrefElement as A } from "./design-system.es125.js";
import { toValue as n, notNullish as g, tryOnScopeDispose as y } from "./design-system.es150.js";
import { createFocusTrap as D } from "./design-system.es840.js";
import { ref as i, computed as F, watch as T } from "vue";
function E(f, a = {}) {
  let e;
  const { immediate: l, ...p } = a, r = i(!1), s = i(!1), c = (t) => e && e.activate(t), u = (t) => e && e.deactivate(t), v = () => {
    e && (e.pause(), s.value = !0);
  }, m = () => {
    e && (e.unpause(), s.value = !1);
  }, d = F(() => {
    const t = n(f);
    return (Array.isArray(t) ? t : [t]).map((h) => {
      const o = n(h);
      return typeof o == "string" ? o : A(o);
    }).filter(g);
  });
  return T(
    d,
    (t) => {
      t.length && (e = D(t, {
        ...p,
        onActivate() {
          r.value = !0, a.onActivate && a.onActivate();
        },
        onDeactivate() {
          r.value = !1, a.onDeactivate && a.onDeactivate();
        }
      }), l && c());
    },
    { flush: "post" }
  ), y(() => u()), {
    hasFocus: r,
    isPaused: s,
    activate: c,
    deactivate: u,
    pause: v,
    unpause: m
  };
}
export {
  E as useFocusTrap
};
//# sourceMappingURL=design-system.es295.js.map
